//export const server = "https://escraowme.cyclic.app/api/v2";
export const server = `https://server.escrowme.net/api/v2`;
export const backend_url = "https://server.escrowme.net/";
//export const backend_url = "https://escraowme.cyclic.app/";
//https://escraowme.cyclic.app/api/v2
